<template>
    <Transition name="fade">
        <div class="nav-bar-wrapper">
            <div class="top-content">
                <div class="logo" @click="logoClickHandler">
                    <transition name="fade">
                        <img
                            class="logo-img"
                            src="@/assets/icons/logo.png"
                            alt="e-chat logo"
                        />
                    </transition>
                </div>
                <nav class="main-navbar">
                    <NavBarList/>
                </nav>
            </div>
        </div>
    </Transition>
</template>
<script>
import ButtonMenuNavBar from "./ButtonMenuNavBar.vue";
import NavBarList from "@/components/NavBar/NavBarList.vue";
import {mapState} from "vuex";

export default {
    components: {
        NavBarList,
    },
    computed: {
        ...mapState({
            menu: (state) => state.navBar.menu,
        })
    },
    methods: {
        logoClickHandler() {
            this.$store.dispatch('navBar/selectItem', this.menu[0])
            this.$router.push({name: 'Integration'})
        }
    }
};
</script>
<style lang="scss" scoped>
.logo {
    width: 40px;
    color: white;
    margin: 0 auto 24px;
    cursor: pointer;

    &-img {
        width: 100%;
    }
}

.main-navbar {
    display: flex;
    flex-direction: column;
    gap: 17px;
}

.nav-bar-wrapper {
    height: 100%;
    width: 100px;
    padding: 24px 0;
    position: fixed;
    top: 0;
    left: 0;
    overflow-x: hidden;
    text-align: center;
    background-color: #08050c;
}

.main-app {
    position: relative;

    display: flex;
}

.left-app {
    .side-bar-out {
        display: none;
    }
}

.right-app {
    z-index: -1;
    width: calc(100% - 100px);

    position: absolute;
    right: 0;

    transition: 0.4s;

    .bottom-right {
        margin-top: 50px;
    }
}

.right-app.center-app {
    width: 100%;
    top: 30px;
}

@media screen and (max-width: 640px) {
    .nav-bar-wrapper {
        min-width: 67px;
        width: 67px;

        left: unset;
        right: 0;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &::-webkit-scrollbar {
            width: 2px;
        }
    }

    .side-bar-out {
        margin: 30px auto 0;
        width: 37px;
        height: 37px;

        flex: 0 0 37px;
        display: flex;
        align-items: center;
        justify-content: center;

        border: none;
        border-radius: 4px;
        background-color: rgba(white, 0.07);

        svg {
            width: 6px;
            height: 12px;
        }
    }
}

@media screen and (max-width: 640px) {
    .nav-close {
        .right-app {
            width: 100%;

            transition: 0.4s;
        }
    }

    .left-app {
        .side-bar-out {
            width: 37px;
            height: 37px;

            position: fixed;
            bottom: 24px;
            right: calc((67px / 2) - (37px / 2));
            z-index: 2;

            flex: 0 0 37px;
            display: flex;
            align-items: center;
            justify-content: center;

            border: none;
            border-radius: 4px;
            background-color: rgba(#000000, 0.9);

            svg {
                width: 6px;
                height: 12px;
                transform: rotate(180deg);
            }
        }
    }

    .right-app {
        width: calc(100% - 71px);

        right: unset;
        left: 0;
    }
}

//Animation
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
